export const WORKSPACE_MATTER = {
  id: 'm-1',
  name: 'Ramirez v. Lone Star Freight',
  caseNumber: '2023-CV-04821',
  type: 'Personal Injury — Trucking',
  status: 'Active — Discovery',
  jurisdiction: 'Harris County, TX — 152nd District Court',
  filedDate: 'Aug 12, 2023',
  responsibleAttorney: 'Sarah Jenkins',
  referralSource: 'Attorney David Morales',
  caseTheory: "Defendant driver violated FMCSA hours-of-service regulations, operating the vehicle while fatigued, directly causing the collision and plaintiff's injuries."
};
export const WORKSPACE_PARTIES = [{
  role: 'Plaintiff',
  name: 'Carlos Ramirez',
  counsel: 'Sarah Jenkins (Festeryga Law)',
  contact: 'c.ramirez@email.com'
}, {
  role: 'Defendant',
  name: 'Lone Star Freight LLC',
  counsel: 'Marcus Thorne (Thorne & Associates)',
  contact: 'legal@lonestarfreight.com'
}, {
  role: 'Defendant Driver',
  name: 'James Whitfield',
  counsel: 'Marcus Thorne (Thorne & Associates)',
  contact: 'N/A'
}, {
  role: 'Expert',
  name: 'Dr. Elena Vasquez',
  counsel: 'Orthopedic Surgery',
  contact: 'dr.vasquez@medexperts.com'
}, {
  role: 'Expert',
  name: 'Dr. Robert Allen',
  counsel: 'Accident Reconstruction',
  contact: 'r.allen@reconengineering.com'
}, {
  role: 'Treating',
  name: 'Dr. Michael Smith',
  counsel: 'Orthopedics, Mercy Hospital',
  contact: 'msmith@mercyhealth.org'
}, {
  role: 'Treating',
  name: 'Dr. Lisa Park',
  counsel: 'Physical Therapy',
  contact: 'lpark@ptrehab.com'
}, {
  role: 'Adjuster',
  name: 'Karen Mitchell',
  counsel: 'Progressive Insurance',
  contact: 'kmitchell@progressive.com'
}];
export const WORKSPACE_KEY_DATES = [{
  event: 'Date of Incident',
  date: 'Oct 12, 2023',
  status: 'past'
}, {
  event: 'Filed',
  date: 'Aug 12, 2023',
  status: 'past'
}, {
  event: 'Initial Disclosures Due',
  date: 'Dec 15, 2023',
  status: 'past'
}, {
  event: 'Deposition — Dr. Smith',
  date: 'Jan 18, 2024',
  status: 'past'
}, {
  event: 'Deposition — James Whitfield',
  date: 'Feb 5, 2024',
  status: 'past'
}, {
  event: 'Mediation',
  date: 'Mar 22, 2024',
  status: 'upcoming'
}, {
  event: 'Discovery Cutoff',
  date: 'Apr 30, 2024',
  status: 'upcoming'
}, {
  event: 'Expert Designation Deadline',
  date: 'May 15, 2024',
  status: 'upcoming'
}, {
  event: 'Trial Setting',
  date: 'Jul 8, 2024',
  status: 'upcoming'
}, {
  event: 'SOL Deadline',
  date: 'Oct 12, 2025',
  status: 'upcoming'
}];
export const WORKSPACE_DOCUMENTS = [{
  id: 'd-1',
  title: 'Initial Petition — Ramirez v. Lone Star Freight.pdf',
  type: 'Pleading',
  batesStart: 'RLSF-0001',
  batesEnd: 'RLSF-0012',
  dateReceived: 'Aug 12, 2023',
  source: 'Local Upload',
  privilegeStatus: 'None',
  ocrQuality: 'Excellent',
  reviewStatus: 'Reviewed',
  isKey: true,
  confidence: 100,
  pages: 12,
  extractedEntities: ['Carlos Ramirez', 'Lone Star Freight LLC', 'Harris County']
}, {
  id: 'd-2',
  title: 'Mercy Hospital ER Records — 10/12/2023.pdf',
  type: 'Medical Record',
  batesStart: 'RLSF-0013',
  batesEnd: 'RLSF-0054',
  dateReceived: 'Sep 05, 2023',
  source: 'Dropbox',
  privilegeStatus: 'None',
  ocrQuality: 'Good',
  reviewStatus: 'Reviewed',
  isKey: true,
  confidence: 98,
  pages: 42,
  extractedEntities: ['Mercy Hospital', 'L4-L5', 'Morphine']
}, {
  id: 'd-3',
  title: 'Dr. Smith Orthopedic Consultation Notes.pdf',
  type: 'Medical Record',
  batesStart: 'RLSF-0055',
  batesEnd: 'RLSF-0072',
  dateReceived: 'Oct 15, 2023',
  source: 'iCloud',
  privilegeStatus: 'None',
  ocrQuality: 'Good',
  reviewStatus: 'Reviewed',
  isKey: false,
  confidence: 95,
  pages: 18,
  extractedEntities: ['Dr. Michael Smith', 'Lumbar Spine', 'MRI']
}, {
  id: 'd-4',
  title: 'MRI Lumbar Spine — 10/18/2023.pdf',
  type: 'Medical Record',
  batesStart: 'RLSF-0073',
  batesEnd: 'RLSF-0078',
  dateReceived: 'Oct 20, 2023',
  source: 'Dropbox',
  privilegeStatus: 'None',
  ocrQuality: 'Excellent',
  reviewStatus: 'Reviewed',
  isKey: false,
  confidence: 97,
  pages: 6,
  extractedEntities: ['Disc Herniation', 'Nerve Root Impingement']
}, {
  id: 'd-5',
  title: 'Physical Therapy Progress Notes — Q4 2023.pdf',
  type: 'Medical Record',
  batesStart: 'RLSF-0079',
  batesEnd: 'RLSF-0110',
  dateReceived: 'Jan 05, 2024',
  source: 'Email',
  privilegeStatus: 'None',
  ocrQuality: 'Fair',
  reviewStatus: 'Pending',
  isKey: false,
  confidence: 88,
  pages: 32,
  extractedEntities: ['Dr. Lisa Park', 'Range of Motion']
}, {
  id: 'd-6',
  title: 'Police Accident Report — Incident #2023-TR-8847.pdf',
  type: 'Evidence',
  batesStart: 'RLSF-0111',
  batesEnd: 'RLSF-0118',
  dateReceived: 'Aug 15, 2023',
  source: 'Local Upload',
  privilegeStatus: 'None',
  ocrQuality: 'Good',
  reviewStatus: 'Reviewed',
  isKey: true,
  confidence: 100,
  pages: 8,
  extractedEntities: ['Officer Davis', 'Intersection', 'Citation Issued']
}, {
  id: 'd-7',
  title: 'Defendant Driver ELD Logs — October 2023.pdf',
  type: 'Discovery',
  batesStart: 'RLSF-0119',
  batesEnd: 'RLSF-0145',
  dateReceived: 'Nov 10, 2023',
  source: 'Email',
  privilegeStatus: 'None',
  ocrQuality: 'Fair',
  reviewStatus: 'Flagged',
  isKey: true,
  confidence: 72,
  pages: 27,
  extractedEntities: ['James Whitfield', 'Hours of Service', 'Violation']
}, {
  id: 'd-8',
  title: 'Lone Star Freight Safety Manual — 2023 Edition.pdf',
  type: 'Discovery',
  batesStart: 'RLSF-0146',
  batesEnd: 'RLSF-0298',
  dateReceived: 'Nov 10, 2023',
  source: 'Email',
  privilegeStatus: 'None',
  ocrQuality: 'Poor',
  reviewStatus: 'Pending',
  isKey: false,
  confidence: 65,
  pages: 153,
  extractedEntities: ['Safety Protocol', 'Fatigue Management']
}, {
  id: 'd-9',
  title: 'Expert Report — Dr. Allen Accident Reconstruction.pdf',
  type: 'Expert Report',
  batesStart: 'RLSF-0299',
  batesEnd: 'RLSF-0324',
  dateReceived: 'Feb 20, 2024',
  source: 'Local Upload',
  privilegeStatus: 'None',
  ocrQuality: 'Excellent',
  reviewStatus: 'Reviewed',
  isKey: true,
  confidence: 100,
  pages: 26,
  extractedEntities: ['Dr. Robert Allen', 'Impact Velocity', 'Braking Distance']
}, {
  id: 'd-10',
  title: 'Deposition Transcript — Dr. Michael Smith.pdf',
  type: 'Deposition',
  batesStart: 'RLSF-0325',
  batesEnd: 'RLSF-0412',
  dateReceived: 'Jan 25, 2024',
  source: 'Local Upload',
  privilegeStatus: 'None',
  ocrQuality: 'Excellent',
  reviewStatus: 'Reviewed',
  isKey: false,
  confidence: 99,
  pages: 88,
  extractedEntities: ['Causation', 'Prognosis', 'Surgery Recommendation']
}, {
  id: 'd-11',
  title: 'Pharmacy Prescription History — Ramirez.pdf',
  type: 'Medical Record',
  batesStart: 'RLSF-0413',
  batesEnd: 'RLSF-0420',
  dateReceived: 'Dec 01, 2023',
  source: 'iCloud',
  privilegeStatus: 'None',
  ocrQuality: 'Good',
  reviewStatus: 'Pending',
  isKey: false,
  confidence: 91,
  pages: 8,
  extractedEntities: ['CVS Pharmacy', 'Oxycodone', 'Muscle Relaxants']
}, {
  id: 'd-12',
  title: 'Demand Letter Draft — v3.docx',
  type: 'Correspondence',
  batesStart: 'N/A',
  batesEnd: 'N/A',
  dateReceived: 'Mar 01, 2024',
  source: 'Local Upload',
  privilegeStatus: 'Work Product',
  ocrQuality: 'Excellent',
  reviewStatus: 'Flagged',
  isKey: false,
  confidence: 100,
  pages: 15,
  extractedEntities: ['Settlement Demand', 'Policy Limits']
}, {
  id: 'd-13',
  title: 'Internal Case Strategy Memo.docx',
  type: 'Correspondence',
  batesStart: 'N/A',
  batesEnd: 'N/A',
  dateReceived: 'Sep 10, 2023',
  source: 'Local Upload',
  privilegeStatus: 'Attorney-Client',
  ocrQuality: 'Excellent',
  reviewStatus: 'Excluded',
  isKey: false,
  confidence: 100,
  pages: 4,
  extractedEntities: ['Weaknesses', 'Jury Appeal']
}, {
  id: 'd-14',
  title: 'Medical Bills Summary — All Providers.xlsx',
  type: 'Billing',
  batesStart: 'RLSF-0421',
  batesEnd: 'RLSF-0428',
  dateReceived: 'Feb 15, 2024',
  source: 'Dropbox',
  privilegeStatus: 'None',
  ocrQuality: 'Excellent',
  reviewStatus: 'Reviewed',
  isKey: true,
  confidence: 94,
  pages: 8,
  extractedEntities: ['Total Specials', 'Liens']
}, {
  id: 'd-15',
  title: 'Scene Photographs — Intersection.zip',
  type: 'Evidence',
  batesStart: 'RLSF-0429',
  batesEnd: 'RLSF-0441',
  dateReceived: 'Aug 20, 2023',
  source: 'Local Upload',
  privilegeStatus: 'None',
  ocrQuality: 'Poor',
  reviewStatus: 'Reviewed',
  isKey: false,
  confidence: 0,
  pages: 13,
  extractedEntities: ['Skid Marks', 'Traffic Signals']
}];
export const WORKSPACE_CHRONOLOGY = [{
  id: 'c-1',
  date: 'Oct 12, 2023',
  provider: 'Mercy Hospital ER',
  facility: 'Mercy Hospital',
  eventType: 'ER Visit',
  description: 'Patient admitted via EMS following MVA. Complains of severe lower back pain radiating down left leg. Administered 5mg Morphine IV.',
  sourceDocId: 'd-2',
  batesRef: 'RLSF-0014',
  significance: 'High',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-2',
  date: 'Oct 14, 2023',
  provider: 'Dr. Michael Smith',
  facility: 'Mercy Orthopedics',
  eventType: 'Consultation',
  description: 'Initial orthopedic consult. Patient reports numbness in left foot. MRI ordered for lumbar spine. Patient reported prior mild back pain in 2019.',
  sourceDocId: 'd-3',
  batesRef: 'RLSF-0056',
  significance: 'High',
  hasAmbiguity: true,
  ambiguityNote: 'Pre-existing condition requires clarification. Need to subpoena 2019 records.'
}, {
  id: 'c-3',
  date: 'Oct 18, 2023',
  provider: 'Mercy Imaging',
  facility: 'Mercy Hospital',
  eventType: 'Imaging',
  description: 'MRI Lumbar Spine without contrast. Findings: Acute disc herniation at L4-L5 with nerve root impingement on the left side.',
  sourceDocId: 'd-4',
  batesRef: 'RLSF-0074',
  significance: 'High',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-4',
  date: 'Oct 25, 2023',
  provider: 'Dr. Michael Smith',
  facility: 'Mercy Orthopedics',
  eventType: 'Follow-up',
  description: 'Reviewed MRI results with patient. Recommended conservative treatment first (PT and epidural steroid injections). Surgery discussed as last resort.',
  sourceDocId: 'd-3',
  batesRef: 'RLSF-0062',
  significance: 'Medium',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-5',
  date: 'Nov 02, 2023',
  provider: 'Dr. Lisa Park',
  facility: 'PT Rehab Center',
  eventType: 'Therapy',
  description: 'Initial PT evaluation. Patient has limited ROM in lumbar spine. Pain level 7/10 during extension.',
  sourceDocId: 'd-5',
  batesRef: 'RLSF-0080',
  significance: 'Medium',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-6',
  date: 'Nov 15, 2023',
  provider: 'Dr. Michael Smith',
  facility: 'Mercy Orthopedics',
  eventType: 'Procedure',
  description: 'Administered first lumbar epidural steroid injection at L4-L5 level under fluoroscopy.',
  sourceDocId: 'd-3',
  batesRef: 'RLSF-0068',
  significance: 'High',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-7',
  date: 'Dec 10, 2023',
  provider: 'Dr. Lisa Park',
  facility: 'PT Rehab Center',
  eventType: 'Therapy',
  description: 'Progress note: Patient reports only temporary relief from ESI. Pain returning to 6/10. Continuing core strengthening.',
  sourceDocId: 'd-5',
  batesRef: 'RLSF-0095',
  significance: 'Medium',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-8',
  date: 'Jan 05, 2024',
  provider: 'Dr. Michael Smith',
  facility: 'Mercy Orthopedics',
  eventType: 'Follow-up',
  description: 'Patient reports conservative treatment failing. Left leg weakness increasing. Scheduled for L4-L5 microdiscectomy.',
  sourceDocId: 'd-3',
  batesRef: 'RLSF-0071',
  significance: 'High',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-9',
  date: 'Jan 18, 2024',
  provider: 'Dr. Michael Smith',
  facility: 'Deposition',
  eventType: 'Consultation',
  description: 'Deposition taken. Dr. Smith testified that the L4-L5 herniation was "more likely than not" caused by the Oct 12 collision.',
  sourceDocId: 'd-10',
  batesRef: 'RLSF-0345',
  significance: 'High',
  hasAmbiguity: false,
  ambiguityNote: null
}, {
  id: 'c-10',
  date: 'Jan 22, 2024',
  provider: 'CVS Pharmacy',
  facility: 'CVS',
  eventType: 'Prescription',
  description: 'Refill of Oxycodone 5mg and Cyclobenzaprine 10mg.',
  sourceDocId: 'd-11',
  batesRef: 'RLSF-0418',
  significance: 'Low',
  hasAmbiguity: false,
  ambiguityNote: null
}];
export const WORKSPACE_SEARCH_HISTORY = [{
  id: 'sh-1',
  query: 'Evidence of driver fatigue or hours of service violations',
  timestamp: '2 hours ago',
  resultCount: 14
}, {
  id: 'sh-2',
  query: 'Dr. Smith opinion on causation',
  timestamp: 'Yesterday',
  resultCount: 5
}, {
  id: 'sh-3',
  query: 'Prior back injuries or pre-existing conditions',
  timestamp: '3 days ago',
  resultCount: 2
}, {
  id: 'sh-4',
  query: 'Speed of truck at impact',
  timestamp: '1 week ago',
  resultCount: 8
}];
export const WORKSPACE_REVIEW_ITEMS = [{
  id: 'ri-1',
  type: 'Chronology Conflict',
  title: 'Pre-existing Condition Mention',
  description: 'Dr. Smith notes mention "prior mild back pain in 2019" which conflicts with intake questionnaire stating no prior back issues.',
  confidence: 92,
  status: 'Pending',
  createdAt: 'Oct 15, 2023',
  sourceDocTitle: 'Dr. Smith Orthopedic Consultation Notes.pdf'
}, {
  id: 'ri-2',
  type: 'Classification',
  title: 'Verify Document Type',
  description: 'System classified document as "Discovery" but it appears to be a mix of ELD logs and internal company emails.',
  confidence: 72,
  status: 'Pending',
  createdAt: 'Nov 10, 2023',
  sourceDocTitle: 'Defendant Driver ELD Logs — October 2023.pdf'
}, {
  id: 'ri-3',
  type: 'Privilege Flag',
  title: 'Potential Work Product',
  description: 'Document contains phrase "settlement strategy" and "confidential attorney work product".',
  confidence: 100,
  status: 'Approved',
  createdAt: 'Mar 01, 2024',
  sourceDocTitle: 'Demand Letter Draft — v3.docx'
}, {
  id: 'ri-4',
  type: 'Extraction Error',
  title: 'Poor OCR Quality',
  description: 'Safety manual text extraction is below quality threshold. Manual review recommended for key sections.',
  confidence: 65,
  status: 'Pending',
  createdAt: 'Nov 10, 2023',
  sourceDocTitle: 'Lone Star Freight Safety Manual — 2023 Edition.pdf'
}, {
  id: 'ri-5',
  type: 'Draft Review',
  title: 'Review Interrogatories',
  description: 'AI generated 15 interrogatories regarding hours of service. Needs attorney approval before finalizing.',
  confidence: 88,
  status: 'Pending',
  createdAt: 'Today',
  sourceDocTitle: 'Draft Interrogatories - HOS.docx'
}, {
  id: 'ri-6',
  type: 'Confidence Alert',
  title: 'Low Confidence Entity Extraction',
  description: 'System could not confidently extract the exact speed from the police report narrative.',
  confidence: 45,
  status: 'Rejected',
  createdAt: 'Aug 15, 2023',
  sourceDocTitle: 'Police Accident Report — Incident #2023-TR-8847.pdf'
}];
export const WORKSPACE_AUDIT_LOG = [{
  id: 'al-1',
  timestamp: 'Today, 09:45 AM',
  user: 'Sarah Jenkins',
  action: 'Viewed Document',
  detail: 'Expert Report — Dr. Allen Accident Reconstruction.pdf'
}, {
  id: 'al-2',
  timestamp: 'Today, 09:30 AM',
  user: 'System',
  action: 'Workflow Completed',
  detail: 'Generated Medical Chronology update from new PT records'
}, {
  id: 'al-3',
  timestamp: 'Yesterday, 04:15 PM',
  user: 'David Chen',
  action: 'Added Tag',
  detail: 'Added tag "High Value" to matter'
}, {
  id: 'al-4',
  timestamp: 'Yesterday, 02:00 PM',
  user: 'Sarah Jenkins',
  action: 'Approved Review Item',
  detail: 'Approved Privilege Flag for Demand Letter Draft'
}, {
  id: 'al-5',
  timestamp: 'Mar 01, 2024, 11:20 AM',
  user: 'Jessica Pearson',
  action: 'Uploaded Document',
  detail: 'Demand Letter Draft — v3.docx via Local Upload'
}, {
  id: 'al-6',
  timestamp: 'Feb 20, 2024, 03:45 PM',
  user: 'System',
  action: 'Auto-Classified',
  detail: 'Classified Expert Report — Dr. Allen Accident Reconstruction.pdf as Expert Report (Confidence: 100%)'
}, {
  id: 'al-7',
  timestamp: 'Feb 20, 2024, 03:40 PM',
  user: 'Sarah Jenkins',
  action: 'Uploaded Document',
  detail: 'Expert Report — Dr. Allen Accident Reconstruction.pdf via Local Upload'
}, {
  id: 'al-8',
  timestamp: 'Feb 15, 2024, 10:00 AM',
  user: 'System',
  action: 'Data Sync',
  detail: 'Synced 1 document from Dropbox'
}, {
  id: 'al-9',
  timestamp: 'Jan 25, 2024, 01:15 PM',
  user: 'System',
  action: 'Entity Extraction',
  detail: 'Extracted 42 entities from Deposition Transcript — Dr. Michael Smith.pdf'
}, {
  id: 'al-10',
  timestamp: 'Jan 18, 2024, 09:00 AM',
  user: 'Sarah Jenkins',
  action: 'Updated Key Date',
  detail: 'Changed Deposition — Dr. Smith status to Completed'
}];
export const WORKSPACE_WORKFLOWS = [{
  id: 'wf-1',
  name: 'Bates Label Production',
  status: 'Ready',
  lastRun: 'Nov 12, 2023',
  duration: '4m 12s',
  stepsCompleted: 0,
  totalSteps: 3
}, {
  id: 'wf-2',
  name: 'Generate Medical Chronology',
  status: 'Completed',
  lastRun: 'Today, 09:30 AM',
  duration: '2m 45s',
  stepsCompleted: 5,
  totalSteps: 5
}, {
  id: 'wf-3',
  name: 'Classify Production Set',
  status: 'Running',
  lastRun: 'Started 2 mins ago',
  duration: '--',
  stepsCompleted: 2,
  totalSteps: 4
}, {
  id: 'wf-4',
  name: 'Extract Deposition Summary',
  status: 'Completed',
  lastRun: 'Jan 25, 2024',
  duration: '5m 30s',
  stepsCompleted: 4,
  totalSteps: 4
}, {
  id: 'wf-5',
  name: 'Identify Privilege Candidates',
  status: 'Failed',
  lastRun: 'Mar 01, 2024',
  duration: '1m 15s',
  stepsCompleted: 1,
  totalSteps: 3
}];
export const WORKSPACE_ACTIVITY = [{
  id: 'act-1',
  timestamp: '2 hours ago',
  user: 'Sarah Jenkins',
  action: 'searched corpus for',
  detail: '"Evidence of driver fatigue or hours of service violations"',
  type: 'user'
}, {
  id: 'act-2',
  timestamp: '3 hours ago',
  user: 'System AI',
  action: 'flagged',
  detail: 'Demand Letter Draft — v3.docx as potential Work Product',
  type: 'ai'
}, {
  id: 'act-3',
  timestamp: 'Yesterday',
  user: 'David Chen',
  action: 'uploaded',
  detail: '3 new medical records from PT Rehab Center',
  type: 'user'
}, {
  id: 'act-4',
  timestamp: 'Yesterday',
  user: 'System',
  action: 'completed workflow',
  detail: 'Generate Medical Chronology',
  type: 'system'
}, {
  id: 'act-5',
  timestamp: '2 days ago',
  user: 'Sarah Jenkins',
  action: 'approved',
  detail: 'draft interrogatories for James Whitfield',
  type: 'user'
}, {
  id: 'act-6',
  timestamp: '1 week ago',
  user: 'System AI',
  action: 'extracted',
  detail: '14 new timeline events from Dr. Smith Deposition',
  type: 'ai'
}, {
  id: 'act-7',
  timestamp: '2 weeks ago',
  user: 'Jessica Pearson',
  action: 'added key date',
  type: 'user',
  detail: 'Mediation scheduled for Mar 22, 2024'
}, {
  id: 'act-8',
  timestamp: '1 month ago',
  user: 'System',
  action: 'synced',
  detail: 'Defendant Driver ELD Logs from Email',
  type: 'system'
}];
export const DOC_CATEGORY_COUNTS = {
  'Medical Records': 6,
  Pleadings: 1,
  Discovery: 2,
  'Expert Reports': 1,
  Depositions: 1,
  Evidence: 2,
  Correspondence: 2,
  Billing: 1
};
export const SOURCE_COUNTS = {
  Dropbox: 4,
  iCloud: 2,
  'Local Upload': 6,
  Email: 3
};
export const MATTER_TAGS = ['Trucking', 'FMCSA Violation', 'Spinal Injury', 'L4-L5', 'Fatigue', 'ELD Logs', 'High Value', 'Expert Designated'];